"use strict";

(() => {
    const initializeQuantitySelector = () => {
        const quantityWrapper = document.querySelector('.product-info__quantity-selector__options');
        const quantityInput = document.querySelector('.quantity-selector input[name="quantity"]');
    
        if (!quantityWrapper || !quantityInput) return;
    
        const clone = quantityWrapper.cloneNode(true);
        quantityWrapper.parentNode.replaceChild(clone, quantityWrapper);
    
        let currentTarget = clone.querySelector('.product-info__quantity-selector__option.active') || null;
    
        clone.addEventListener('click', (e) => {
            const quantityOption = e.target.closest('.product-info__quantity-selector__option');
        
            if (!quantityOption || !clone.contains(quantityOption)) return;
        
            const quantityInput = document.querySelector('.product-info__quantity-selector .quantity-selector input[name="quantity"]');
            if (!quantityInput) return;
        
            const quantity = quantityOption.dataset.itemQuantity;
            if (!quantity) return;
    
            quantityInput.value = quantity;
            quantityInput.click();
            
            const appstleWidgetOneTime = document.querySelector('.appstle_one_time_details_wrapper > input');
            const appstleWidgetSubs = document.querySelector('.appstle_subscription_radio_wrapper > input');

            if(appstleWidgetOneTime && appstleWidgetSubs) {
                appstleWidgetSubs.click();
                appstleWidgetOneTime.click();
            }
        
            if (currentTarget && currentTarget !== quantityOption) {
                currentTarget.classList.remove('active');
            }
        
            quantityOption.classList.add('active');
            currentTarget = quantityOption;

            const sealsUnitPrice = document.querySelector('.sls-price .money.conversion-bear-money');
            const currentOptionUnitPrice = currentTarget.querySelector('.product-info__quantity-selector__unit-price span');
            const sealsSingleOption = document.querySelector('.sls-option-container:first-of-type');

            if(sealsUnitPrice && currentOptionUnitPrice) {
                sealsUnitPrice.innerHTML = currentOptionUnitPrice.innerHTML;
            }

            if(!sealsSingleOption || window.observerMounted) return;

            const observer = new MutationObserver(() => {
                const sealsUnitPrice = document.querySelector('.sls-price .money.conversion-bear-money');
                const currentOptionUnitPrice = currentTarget.querySelector('.product-info__quantity-selector__unit-price span');

                sealsUnitPrice.innerHTML = currentOptionUnitPrice.innerHTML;
            });

            observer.observe(sealsSingleOption, { attributes: true, subtree: true });

            window.observerMounted = true;
        });
    };
    
    initializeQuantitySelector();

    const getVariantId = (url) => {
        const params = new URLSearchParams(url);
        return params.get("variant");
    };
    
    let currentUrl = getVariantId(location.search);
    
    const checkForVariantChange = () => {
        if (getVariantId(location.search) !== currentUrl) {
            currentUrl = getVariantId(location.search);
            const hasCustomQuantityPicker = document.querySelector('.product-info__quantity-selector__options');

            if(hasCustomQuantityPicker) {
                setTimeout(() => {
                    initializeQuantitySelector();
    
                    const firstOptionButton = document.querySelector('.product-info__quantity-selector__option');
    
                    if(firstOptionButton) {
                        firstOptionButton.click();
                    }
                }, 50);
            } else {
                if (!document.querySelector('.product-info__quantity-selector__options')) {
                        setTimeout(() => {
                        const quantityInput = document.querySelector('.product-info__quantity-selector .quantity-selector');
                    
                        if (quantityInput) {
                            if (!quantityInput.dataset.listenerAttached) {
                                quantityInput.addEventListener('click', () => {
                                    const appstleWidgetOneTime = document.querySelector('.appstle_one_time_details_wrapper > input');
                                    const appstleWidgetSubs = document.querySelector('.appstle_subscription_radio_wrapper > input');
                    
                                    if (appstleWidgetOneTime && appstleWidgetSubs) {
                                        appstleWidgetSubs.click();
                                        appstleWidgetOneTime.click();
                                    }
                                });
                    
                                quantityInput.dataset.listenerAttached = "true";
                            }
                        }
                    }, 50);
                }                
            }
        }
    };
    
    window.addEventListener('popstate', checkForVariantChange);
    
    ['pushState', 'replaceState'].forEach((method) => {
        const original = history[method];
        history[method] = function(...args) {
            const result = original.apply(this, args);
            checkForVariantChange();
            return result;
        };
    });
})();
